import contentMonitor from "@/components/content-spm"
import setIwtReportParams from "@/components/iwtReport"
import reportReadDuration from '@/components/report/readDurationReport'

export default function(opts) {
    // 老逻辑：正文部分行为统计（滑动到一半滑动到结尾）
    new contentMonitor({ el: 'article' })
    // 老逻辑：向艾瑞上报所需参数
    setIwtReportParams(opts)
    // 新逻辑：完读停留时长上报
    reportReadDuration(opts)
}
